const messages = type =>
  I18n.t(type, {
    scope: 'components.ibe.remark_types',
  });

const remarkTypeBuilder = types => types.map(type => ({ value: type, label: messages(type) }));

export default remarkTypeBuilder;
